import { IS_MOBILE } from "./utils/tool";
//设计稿尺 寸
let designSize = 393;
let fontSize = "12px";
const resize = () => {
  let html = document.documentElement;
  if (IS_MOBILE) {
    let clientW = html.clientWidth;
    // html 的fontsize 大小
    fontSize = (clientW * 12) / designSize + "px";
  }
  html.style.fontSize = fontSize;
};
resize();
window.addEventListener("resize", resize);
